
import "./Statistica.css";
import React, { useEffect, useState } from "react";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const  AddTooltip = ({ payload } : { payload: any }) => {
    if (payload) {
        return (
            <div
                className = "custom-tooltip"
                style = {{
                    width: "auto",
                    height: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#ffff",
                    padding: "5px 10px",
                    boxShadow: "0 0 5px rgba(0,0,0,0.5)",
                    borderRadius: "7px"
                }}
            >
                <label className="circleChartValueText">{ `Added : ${payload[0]?.value}` }</label>
                <label className="circleChartValueText">{ `Canceled : ${payload[1]?.value}` }</label>
            </div>
        );
    }
    return null;
};

function AddCancelChart({ addClients, canselations, showDate } : { addClients: any, canselations: any, showDate: string[] }) {

    const [addCancelClientsData, setAddCanselClientsData] = useState<Array<any>>([]);

    useEffect(() => {
        if (addClients && canselations) {
            const addClientsData = new Array();
            const cancelClientsData = new Array();
            for ( let key in addClients ) {
                let obj = {
                    count: addClients[key],
                    date: key
                }
                addClientsData.push(obj);
            }
            for ( let key in canselations ) {
                let obj = {
                    count: canselations[key],
                    date: key
                }
                cancelClientsData.push(obj);
            }

            const allChartData = new Array();

            showDate.forEach((date: string) => {
                const findAddData = addClientsData.find((addData: any) => addData.date === date);
                const findCancelData = cancelClientsData.find((cancelData: any) => cancelData.date === date);
                let obj = {
                    addCount: findAddData ? findAddData.count : 0,
                    cancelCount: findCancelData ? findCancelData.count : 0,
                    date: date.slice(5).replace("/", ".")
                }
                allChartData.push(obj);
            })
            setAddCanselClientsData(allChartData);
        }
    }, [addClients, canselations, showDate]);

    return(
        <div className = "AddCancelChart">
            <span className = "activeClientsTitle">
                Clients
            </span>
            <ResponsiveContainer width = "100%" height = { 350 }>
                <LineChart
                    data = { addCancelClientsData }
                    style = {{
                        fontSize: "12px",
                        fontFamily: "'Poppins', sans-serif",
                        margin: 0,
                    }}
                >
                    <Line type = "monotone" dataKey = "addCount" stroke = "#63C061"/>
                    <Line type = "monotone" dataKey = "cancelCount" stroke = "red"/>
                    <CartesianGrid vertical = { false } stroke = { "rgba(0,0,0,0.1)" }/>
                    <XAxis dataKey = "date" stroke = { "#666666" }/>
                    <YAxis type = "number" stroke = { "#212121" } domain = { [0, 'dataMax+10'] }/>
                    <Tooltip
                        content = { <AddTooltip payload = { addCancelClientsData }/> }
                    />
                </LineChart>

            </ResponsiveContainer>
        </div>
    )
}

export default AddCancelChart;